import createTheme from '@@/create-theme';

export default createTheme({
    page: () => import('./components/root'),
    locales: ['zh-CN', 'en'],
    components: {
        'activate:editor': () => import('./components/updater'),
    }
});
